<template>
  <div>
    <br />
    <b-row>
      <b-col class="text-left mt-2">
        <h5 class="font-weight-bold text-primary">S&K Category</h5>
      </b-col>
      <b-col class="text-right">
        <router-link :to="{name: 'createTncCategory'}">
          <b-button variant="primary">
            <img src="@/assets/create-new.svg" class="mr-2" alt />Create New
          </b-button>
        </router-link>
      </b-col>
    </b-row>
    <br />
    <div class="text-left">
      <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section>
      <b-table
        v-else
        responsive
        show-empty
        hover
        ref="faqCategory"
        :items="getInfo"
        :fields="categories"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(created_at)="{ value, item }">
          <p class="mb-0">{{item.created_at_date_only}}</p>
          by {{item.created_by_username}}
        </template>
        <template v-slot:cell(updated_at)="{ value, item }">
          <div v-if="item.updated_at_date_only == ''">-</div>
          <div v-else>
            <p class="mb-0">{{item.updated_at_date_only}}</p>
            by {{item.updated_by_username}}
          </div>
        </template>
        <template v-slot:cell(action)="{value,item}">
          <router-link
            v-b-tooltip.hover
            title="Edit"
            :to="{name: 'editTncCategory', params: {id: item.id}}"
            class="text-dark"
          >
            <img src="@/assets/ic-edit.svg" class="mr-2" alt />
          </router-link>
          <!-- <b-link v-b-tooltip.hover title="Delete" class="text-dark" @click="del(item.id)">
            <img src="@/assets/rectangle.svg" class="mr-2" alt />
          </b-link>-->
          <!-- <b-link
            :class="{'order-link':item.order_field === 1}"
            @click="orderFaqCategory({id:item.id,change:'up'})"
            class="text-primary"
            v-b-tooltip.hover
            title="Up Order"
          >
            <i class="fas fa-arrow-up mr-2"></i>
          </b-link>
          <b-link
            class="text-primary"
            v-b-tooltip.hover
            title="Down Order"
            :class="{'order-link':item.order_field === totalRows}"
            @click="orderFaqCategory({id:item.id,change:'down'})"
          >
            <i class="fas fa-arrow-down"></i>
          </b-link>-->
        </template>
      </b-table>
      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{totalRows}}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      errored: false,
      items: [],
      categories: [
        {
          key: "created_at",
          label: "Created",
          sortable: true,
          class: "text-left"
        },
        {
          key: "name",
          label: "Category",
          sortable: true,
          class: "text-left"
        },
        // {
        //   key: "category_name.en",
        //   label: "Category (English)",
        //   sortable: true,
        //   class: "text-left"
        // },
        {
          key: "updated_at",
          label: "Updated",
          sortable: true,
          class: "text-left"
        },
        { key: "action", label: "Action", class: "text-center" }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: true,
      sortDirection: "asc",
      filter: "",
      customerShow: false,
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    },
    rows() {
      return this.items.length;
    }
  },
  beforeCreate() {},
  created() {},
  methods: {
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", ctx.sortDesc);
      this.$store
        .dispatch("TncCategoryModule/getTncCategorys", formData)
        .then(response => {
          // let arr = response.data.data.map(data => {
          //   let article = JSON.parse(data.results);
          //   return {
          //     content: article.content.id,
          //     title: article.title.id,
          //     category: article.category
          //   };
          // });
          // vm.items = arr;
          vm.totalRows = response.data.data.total_record;
          callback(response.data.data.results || []);
          this.loading = false;
        })
        .catch(error => {
          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          // Returning an empty array, allows table to correctly handle
          // internal busy state in case of error
          this.isBusy = false;
          callback([]);
        });
      return null;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    orderFaqCategory(order) {
      this.loading = true;
      const orderData = {
        change_type: order.change
      };
      this.$store
        .dispatch("TncCategoryModule/orderTncCategory", {
          id: order.id,
          orderData
        })
        .then(response => {
          this.$refs.faqCategory.refresh();
          this.$swal({
            type: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1500
          });
          console.log(response);
        })
        .catch(error => {
          this.loading = false;
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500
          });
          this.serverError = error.response.data;
          console.log(error);
        });
    },
    del(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("TncCategoryModule/delTncCategory", id);
          this.$refs.faqCategory.refresh();
          this.$swal("Deleted!", "Your file has been deleted.", "success");
        }
      });
    }
  }
};
</script>

<style>
</style>
